import './table.css'

export function TableError(props) {
  return (
    <section style={props.show ? { display: 'flex' } : { display: 'none' }} className='modal-upload-error'>
      <div className='content-modal-upload-error'>
        <div className='title-modal-upload'>
          <h1>Overview Update</h1>
          <h2 onClick={() => props.onClick(false)}>X</h2>
        </div>
        <p style={{ marginTop: 30, fontSize: 18, textAlign: 'center' }}>Foram deletados <b>{props.arr.length}</b> item(s) do projeto</p>
        <div style={{ height: '80%', overflow: 'hidden', marginTop: 40, width: '80%' }}>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <td style={{ fontSize: 15, fontWeight: 600, color: '#0F0742' }}>Tabela</td>
                <td style={{ width: '50%', textAlign: 'center', fontSize: 15, fontWeight: 600, color: '#0F0742' }}>Elementos</td>
              </tr>
            </thead>
            <tbody>
              {
                props.arr.map(value => {
                  return (
                    <tr>
                      <td style={{ width: '50%', fontSize: 15, paddingTop: 15 }}>{value.tabela}</td>
                      <td style={{ width: '50%', textAlign: 'center', fontSize: 15 }}>{value.fields}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <div className='background-blur'>
          <button onClick={() => props.dowload(false)}> Okay</button>
        </div>
      </div>
    </section>
  )
}
